import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { RoutesConfig } from "../router/types";
import { useSelectedItemStore } from "../store/useSelectedItemStore";

interface LinkAbrirProps {
  item: any;
}

const LinkAbrir: React.FC<LinkAbrirProps> = ({ item }) => {
  const navigate = useNavigate();
  const setSelectedItemId = useSelectedItemStore((s) => s.setSelectedItemId);
  const handleClick = () => {
    setSelectedItemId(item.CD_PROCESSO);
    navigate(RoutesConfig.DETALHESPROCESSO.path);
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        userSelect: "none",
        color: "#0A0C33",
        textDecoration: "underline",
        fontWeight: 500,
        fontSize: "14px",
      }}
    >
      <Typography component="span" sx={{ textDecoration: "inherit" }}>
        Abrir
      </Typography>
      <OpenInNewIcon
        fontSize="small"
        sx={{ ml: "4px", verticalAlign: "middle" }}
      />
    </Box>
  );
};

export default LinkAbrir;
